import React from "react";
import styles from "./styles.module.scss";

type AlertVariant = "info" | "success" | "warning" | "error";

interface ContractAlertProps {
  title?: string;
  description?: string;
  variant?: AlertVariant;
  iconSrc?: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
  className?: string;
}

const variantToClassName: Record<AlertVariant, string> = {
  info: styles.info,
  success: styles.success,
  warning: styles.warning,
  error: styles.error,
};

const ContractAlert: React.FC<ContractAlertProps> = ({
  title,
  description,
  variant = "info",
  iconSrc,
  ctaLabel,
  onCtaClick,
  className,
}) => {
  return (
    <div
      className={[styles.container, variantToClassName[variant], className]
        .filter(Boolean)
        .join(" ")}>
      {iconSrc ? (
        <img className={styles.icon} src={iconSrc} alt="alert" />
      ) : null}
      <div className={styles.content}>
        {title ? <h3 className={styles.title}>{title}</h3> : null}
        {description ? (
          <p className={styles.description}>{description}</p>
        ) : null}
      </div>
      {ctaLabel && onCtaClick ? (
        <button className={styles.ctaButton} onClick={onCtaClick}>
          {ctaLabel}
        </button>
      ) : null}
    </div>
  );
};

export default ContractAlert;
